import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Input, Checkbox, Alert, Button, Icon, Select } from 'antd'

import CategorySelect from '@components/CategorySelect'
import ConfirmButton from '@components/ConfirmButton'

import { categories } from '@services/api'

import { isObjEmpty } from '@utils/index'

import { actionType } from '@texts/categories'

@inject((store: any) => {
    const { popupStore, categoriesStore, authStore } = store
    return { popupStore, categoriesStore, authStore }
})
@observer
export default class CategoryPopup extends Component<any, any> {
    state: any = {
        editedCategory: {},
        mainCategory: false,
        edited: false,
        errors: {}
    }

    handleEditCategory = (name, val) => {
        this.setState(prevState => ({
            ...prevState,
            edited: true,
            editedCategory: { ...prevState.editedCategory, [name]: val }
        }))
    }

    validateCategory = () => {
        const { editedCategory, mainCategory } = this.state
        if ('name' in editedCategory && editedCategory.name.length === 0) {
            this.setState({ errors: { nameError: 'חובה למלא שם קטגוריה' } })
            return false
        }
        if ('parent_id' in editedCategory && !mainCategory && !editedCategory['parent_id']) {
            this.setState({ errors: { parentError: 'במידה והקטגוריה אינה ראשית עליך לבחור הורה' } })
            return false
        }
        this.setState({ errors: {} })
        return true
    }

    updateParent = () => {
        const { editedCategory } = this.state
        const { info } = this.props.popupStore
        if (!('id' in info) && !('parent_id' in editedCategory) && 'parent_id' in info) {
            this.handleEditCategory('parent_id', info.parent_id)
        }
    }

    deleteCategory = async () => {
        const errors = {}
        const { info } = this.props.popupStore
        const { indexedParents } = this.props.categoriesStore
        if (info.usersCount > 0) errors['usersError'] = 'לא ניתן למחוק קטגוריה המשוייכת למשתמשים'
        if (info.policiesCount > 0) errors['policiesError'] = 'לא ניתן למחוק קטגוריה המשוייכת לפוליסות'
        if (indexedParents[info.id]) errors['childrenError'] = 'לא ניתן למחוק קטגוריה בעלת תת קטגוריות'
        this.setState({ errors })
        if (!isObjEmpty(errors)) {
            try {
                await categories.deleteCategory(info.id)
                this.props.categoryUpdated()
                this.closePopup()
            } catch (e) {
                this.setState({ errors: { serverError: 'אירעה שגיאה בחיבור לשרת' } })
            }
        }
    }

    submitCategory = async () => {
        const { editedCategory } = this.state
        const { info } = this.props.popupStore
        if (this.validateCategory()) {
            try {
                if ('id' in info) {
                    await categories.updateCategory({ params: editedCategory, id: info.id })
                } else {
                    await this.updateParent()
                    await categories.addCategory({
                        info: this.state.editedCategory,
                        type: this.props.categoriesStore.type
                    })
                }
                this.props.categoryUpdated()
                this.closePopup()
            } catch (e) {
                this.setState({ errors: { serverError: 'שגיאה בשליחת הנתונים לשרת' } })
            }
        }
    }

    closePopup = () => {
        this.setState({ editedCategory: {}, edited: false, errors: {} })
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const { popupStore, categoriesStore, authStore } = this.props
        const { editedCategory, mainCategory, errors, edited } = this.state

        const styles = {
            input: { direction: 'ltr', textAlign: 'right' },
            title: {
                fontSize: '1rem',
                margin: '0 0 0.2rem',
                fontWeight: 500,
                width: '100%',
                textAlign: 'right',
                display: 'inline-block'
            },
            select: { width: '100%' },
            cardHead: { borderBottom: 'none', backgroundColor: 'white', display: 'none' },
            cardBody: { padding: '0rem', backgroundColor: 'white' },
            cardStyle: { marginBottom: '0', border: 'none' },
            error: { color: 'red' }
        } as React.CSSProperties

        const categorySelect = (
            <Fragment>
                <strong style={{ ...styles['title'] }}>קטגוריית הורה</strong>
                <CategorySelect
                    styles={styles}
                    categoryChanged={value => this.handleEditCategory('parent_id', value)}
                    disabled={false}
                />
            </Fragment>
        )

        const actionSelect = (
            <Fragment>
                <strong style={{ ...styles['title'] }}>בחירת פעולה</strong>
                <Select
                    disabled={!categoriesStore.editing}
                    onChange={e => this.handleEditCategory('action', e)}
                    value={'action' in editedCategory ? editedCategory['action'] : popupStore.info.action}
                    placeholder="בחר את הפעולה"
                    style={{ width: '100%' }}
                >
                    <Select.Option value={null}>ללא פעולה</Select.Option>
                    <Select.Option value="HEALTH_RIGHT">{actionType['HEALTH_RIGHT']}</Select.Option>
                    <Select.Option value="DOCTOR">{actionType['DOCTOR']}</Select.Option>
                    <Select.Option value="CLINIC">{actionType['CLINIC']}</Select.Option>
                    <Select.Option value="KEYWORD">{actionType['KEYWORD']}</Select.Option>
                </Select>
            </Fragment>
        )

        const parentSelect =
            'parent_id' in editedCategory
                ? !mainCategory
                    ? categorySelect
                    : ''
                : !!popupStore.info.parent_id
                ? categorySelect
                : ''

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                {categoriesStore.editing ? (
                    <div style={{ float: 'left', display: 'inline-block' }}>
                        {popupStore.info.id && authStore.roles.includes('admin') ? (
                            <ConfirmButton
                                confirmed={() => this.deleteCategory()}
                                confirmQuestion="למחוק קטגוריה?"
                                buttonText="מחק קטגוריה"
                            />
                        ) : null}
                    </div>
                ) : (
                    ''
                )}
                <Button onClick={this.closePopup}>ביטול</Button>
                {categoriesStore.editing ? (
                    <Button disabled={!edited} type="primary" onClick={this.submitCategory}>
                        {popupStore.info.id ? 'שמירת שינויים' : 'הוסף קטגוריה'}
                    </Button>
                ) : (
                    ''
                )}
            </div>
        )
        return (
            <Modal
                title={
                    popupStore.info.id
                        ? `עריכת קטגוריית ${popupStore.info.name} (${popupStore.info.id})`
                        : 'הוספת קטגוריה'
                }
                visible={popupStore.popupType === 'category'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
            >
                <strong style={{ ...styles['title'] }}>שם הקטגוריה</strong>
                <Input
                    disabled={!categoriesStore.editing}
                    value={'name' in editedCategory ? editedCategory['name'] : popupStore.info.name}
                    placeholder="הזן את שם הקטגוריה"
                    onChange={e => this.handleEditCategory('name', e.target.value)}
                />
                {'nameError' in errors && <span style={{ ...styles['error'] }}>{errors['nameError']}</span>}
                <div style={{ margin: '0.5rem 0' }}>
                    {parentSelect}
                    <Checkbox
                        disabled={!categoriesStore.editing}
                        checked={'parent_id' in editedCategory ? mainCategory : !popupStore.info.parent_id}
                        onChange={e => {
                            this.props.categoriesStore.updateSelectedByCategory(null)
                            this.handleEditCategory('parent_id', null)
                            this.setState({ mainCategory: !!e.target.checked })
                        }}
                    >
                        זוהי קטגוריה ראשית
                    </Checkbox>
                </div>
                {'parentError' in errors && <span style={{ ...styles['error'] }}>{errors['parentError']}</span>}
                {/* {actionSelect} */}
                {popupStore.info.policiesCount > 0 ? (
                    <Alert
                        message={`נמצאו ${popupStore.info.policiesCount} פוליסות מקושרות`}
                        description={
                            errors['policiesError'] ? (
                                <strong style={{ color: '#ff4d4f' }}>* {errors['policiesError']}</strong>
                            ) : (
                                ''
                            )
                        }
                        type={errors['policiesError'] ? 'error' : 'info'}
                        style={{ marginTop: '0.5rem' }}
                    />
                ) : (
                    ''
                )}
                {popupStore.info.usersCount > 0 ? (
                    <Alert
                        message={`נמצאו ${popupStore.info.usersCount}  לקוחות מקושרים`}
                        description={
                            errors['usersError'] ? (
                                <strong style={{ color: '#ff4d4f' }}>* {errors['usersError']}</strong>
                            ) : (
                                ''
                            )
                        }
                        type={errors['usersError'] ? 'error' : 'info'}
                        style={{ marginTop: '0.5rem' }}
                    />
                ) : (
                    ''
                )}
                {categoriesStore.indexedParents[popupStore.info.id] ? (
                    <Alert
                        message={`נמצאו ${categoriesStore.indexedParents[popupStore.info.id].length} תת קטגוריות`}
                        description={
                            errors['childrenError'] ? (
                                <strong style={{ color: '#ff4d4f' }}>* {errors['childrenError']}</strong>
                            ) : (
                                ''
                            )
                        }
                        type={errors['childrenError'] ? 'error' : 'info'}
                        style={{ marginTop: '0.5rem' }}
                    />
                ) : (
                    ''
                )}
            </Modal>
        )
    }
}
